// js/common/utilities/format-money.js
var ENDPOINT =
  "https://cooperandco.com.au/apps/datajet/task/69d4e128649e91cf20d321ae";

function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
    formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."),
      dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        "$1" + thousands,
      ),
      centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}

function togglePincode() {
  var box = document.getElementById("pincodeBox");
  box.classList.toggle("active");
}

function addBusinessDays(date, days) {
  const result = new Date(date);
  let addedDays = 0;

  while (addedDays < days) {
    result.setDate(result.getDate() + 1);

    const day = result.getDay();
    // 0 = Sunday, 6 = Saturday
    if (day !== 0 && day !== 6) {
      addedDays++;
    }
  }

  return result;
}

function getCurrentSKU() {
  // Try Shopify global object (best method)
  if (window.Shopify && ShopifyAnalytics && ShopifyAnalytics.meta) {
    const variants = ShopifyAnalytics.meta.product.variants;
    const selectedId = document.querySelector('[name="id"]')?.value;

    const matched = variants.find((v) => v.id == selectedId);
    if (matched) return matched.sku;
  }

  // Fallback (Liquid)
  return currentSKU;
}

function getQty() {
  var qtyInput = document.querySelector('[name="quantity"]');
  if (qtyInput) {
    var q = parseInt(qtyInput.value, 10);
    if (!isNaN(q) && q > 0) return q;
  }
  return 1;
}

function checkDelivery() {
  const loader = document.getElementById("shipping-loader");
  const resultBox = document.getElementById("result");
  const pincode = document
    .getElementById("shipping_estimator_postcode")
    .value.trim();
  const errorBox = document.getElementById("pincodeError");
  const sku = getCurrentSKU();
  var qty = getQty();
  const btn = document.getElementById("shipping-estimator-btn");
  const btnDataSet = {
    expectedDate: btn.dataset.expected_shipment_date,
    estimatedMsg: btn.dataset.estimated_msg,
    productPreorder: btn.dataset.product_preorder,
    productAvailable: btn.dataset.product_availability,
  };

  if (!pincode) {
    errorBox.innerText = "Please enter postcode";
    errorBox.style.display = "block";

    document.getElementById("result").innerHTML = "";
    return;
  } else {
    errorBox.style.display = "none";
  }

  loader.style.display = "block";
  resultBox.innerHTML = "";

  fetch(ENDPOINT, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ postcode: pincode, sku: sku, quantity: qty }),
  })
    .then(function (res) {
      return res.json();
    })
    .then(function (data) {
      console.log(data);
      // ✅ HIDE LOADER
      loader.style.display = "none";
      if (data.error || !data.rates || data.services.length === 0) {
        loader.style.display = "none";
        resultBox.classList.add("error");
        resultBox.innerHTML = "Services not available for this postcode"; 
        return;
      }
       resultBox.classList.remove("error");
      finalOutput(data, btnDataSet);
    })
    .catch(err => {
      loader.style.display = "none";
      resultBox.innerHTML = "Something went wrong";
      console.error(err);
    });
}
function finalOutput(item, btnDataSet) {
  var postcodeMatch = item.postcode;
  var zoneName = item.zone; // "Zone 3"
  var state = item.state;
  if (!postcodeMatch && item.services.length === 0) {
    document.getElementById("result").innerHTML = "Delivery not available";
    return;
  }
  const shippingData = item.rates;
  // ✅ Price from zone
  var price = null;
  var service = null;
  shippingData.forEach((rate) => {
    if (rate.name.includes("Standard")) {
      price = rate.price;
      service = rate.name;
    } else if (rate.name.includes("Premium")) {
      price = rate.price;
      service = rate.name;
    }
  });
  // 👉 Convert "Zone 3" → "zone_3"
  const zoneKey = zoneName.toLowerCase().replace(" ", "_");
  // ✅ Delivery days map
  const zoneDeliveryDays = {
    zone_1: { min: 3, max: 5 },
    zone_2: { min: 3, max: 6 },
    zone_3: { min: 3, max: 6 },
    zone_4: { min: 3, max: 7 },
    zone_5: { min: 4, max: 7 },
    zone_6: { min: 4, max: 9 },
    zone_7: { min: 3, max: 6 },
    zone_8: { min: 4, max: 8 },
    zone_9: { min: 5, max: 8 },
    zone_10: { min: 7, max: 12 },
    zone_11: { min: 8, max: 13 },
    zone_12: { min: 4, max: 8 },
  };

  const delivery = zoneDeliveryDays[zoneKey];
  const today = new Date();
  // ✅ keep as Date object
  const shipmentDate = new Date(btnDataSet.expectedDate);
  if (btnDataSet.productPreorder && !isNaN(shipmentDate)) {
    // ✅ replace today with shipment date
    today.setTime(shipmentDate.getTime());
  }
  const dispatchDate = addBusinessDays(today, 1); // Assuming dispatch is next business day
  const minDate = addBusinessDays(dispatchDate, delivery.min);
  const maxDate = addBusinessDays(dispatchDate, delivery.max);

  const options = {
    day: "numeric",
    month: "short",
  };

  const minFormatted = minDate.toLocaleDateString("en-GB", options);
  const maxFormatted = maxDate.toLocaleDateString("en-GB", options);

  // ✅ Final Output
  // const matchedServices = shippingData.shipping_matrix.filter(
  //   (item) => item.sku === sku,
  // );
  console.log("Current SKU:", item.sku);
  let outputHTML = `<div class="delivery-result"><div class="delivery-result--item"><strong>Delivering to: ${state}, ${postcodeMatch}</strong></div>`;

  if (!postcodeMatch) {
    outputHTML += `<div class="delivery-result--item">Shipping not available</div>`;
  } else {
    const FormatedPrice = formatMoney(price * 100);
    if (FormatedPrice) {
      outputHTML += `<div class="delivery-result--item"><p>${service}:</p><p> ${FormatedPrice}</p></div>`;
    }
  }
  if ( btnDataSet.productAvailable == 'true'){
    outputHTML += `
      <div class="delivery-result--item"><p>${btnDataSet.estimatedMsg}</p> <p>${minFormatted} - ${maxFormatted}</p></div>
      </div>
      `;
  }else{
    outputHTML += `
      <div class="delivery-result--item"><p>${btnDataSet.estimatedMsg}</p></div>
      </div>
      `;
  }

  document.getElementById("result").innerHTML = outputHTML;
}

// Optional: clear result on variant change
document.addEventListener("change", function (e) {
  if (e.target.name === "id") {
    document.getElementById("result").innerHTML = "";
  }
});
